<template>
  <div class="box4">
    <div class="box4block" ref="block"></div>
    <div class="box4-top">
      <pageTitle title="采用必修+拓展模式授课<br/>高效就业、灵活提升" />
    </div>
    <div class="box4-title">
      <p>必修课<b> · 成为新时代复合型开发者</b></p>
      <img src="../../../assets/coursePage/java/box4/leg.png" />
    </div>
    <div class="box4-btm-box">
      <div class="box4-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject"
          :key="index"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)" ref="item">
            <div class="title">
              <!-- <p v-show="item.stage">{{ item.stage }}</p> -->
              <span>{{ item.title }}</span>
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>
            <template v-if="item.multipleArr">
              <div class="tab">
                <a
                  v-for="(itemInner, indexInner) in item.multipleArr"
                  :key="indexInner"
                  :class="tabIndex == indexInner ? 'current' : ''"
                  @click="changeTabCur(indexInner)"
                  >{{ itemInner.tab }}</a
                >
              </div>
              <div v-if="item.multipleArr[tabIndex]">
                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/01.png"
                    alt
                  />主要内容
                </div>
                <div class="main-content">
                  <div
                    class="block"
                    v-for="i in item.multipleArr[tabIndex].content"
                    :key="i"
                  >
                    {{ i }}
                  </div>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/02.png"
                    alt
                  />特色亮点
                </div>
                <div class="main-text">
                  <p v-for="j in item.multipleArr[tabIndex].light" :key="j" v-html="j">
                  
                  </p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/03.png"
                    alt
                  />可掌握的能力
                </div>
                <div class="main-text">
                  <p v-for="k in item.multipleArr[tabIndex].ability" :key="k">
                    {{ k }}
                  </p>
                </div>
              </div>
            </template>
            <div v-else>
              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/01.png"
                  alt
                />主要内容
              </div>
              <div class="main-content">
                <div
                  class="block"
                  v-for="i in item.content"
                  :key="i"
                >
                  {{ i }}
                </div>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/02.png"
                  alt
                />特色亮点
              </div>
              <div class="main-text">
                <p v-for="j in item.light" :key="j" v-html="j" :class="j.indexOf('<i>')>-1?'three':''"></p>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/03.png"
                  alt
                />可掌握的能力
              </div>
              <div class="main-text">
                <p v-for="k in item.ability" :key="k">{{ k }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn" @click="openDetail">查看详细大纲</div>
    </div>
    <div class="box4-title" style="margin-top: 0;">
      <p>拓展课<b> · 提升职场竞争力</b></p>
      <a>免费赠送</a>
    </div>
    <div class="box4-btm-box">
      <div class="box4-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject2"
          :key="index"
          :style="{
            backgroundColor:
              cur2 == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur2(index)" ref="item">
            <div class="title">
              <!-- <p v-show="item.stage">{{ item.stage }}</p> -->
              {{ item.title }}
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur2 == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur2 == index && showAnswer }"
          >
            <div class="line"></div>
            <template v-if="item.multipleArr">
              <div class="tab">
                <a
                  v-for="(itemInner, indexInner) in item.multipleArr"
                  :key="indexInner"
                  :class="tabIndex == indexInner ? 'current' : ''"
                  @click="changeTabCur(indexInner)"
                  >{{ itemInner.tab }}</a
                >
              </div>
              <div  v-if="item.multipleArr[tabIndex]">
                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/01.png"
                    alt
                  />主要内容
                </div>
                <div class="main-content">
                  <div
                    :class="[
                      index == 4 ||
                      index == 6 ||
                      index == 7 ||
                      index == 8 ||
                      index == 9
                        ? 'main-text2'
                        : 'block',
                    ]"
                    v-for="i in item.multipleArr[tabIndex].content"
                    :key="i"
                  >
                    {{ i }}
                  </div>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/02.png"
                    alt
                  />特色亮点
                </div>
                <div class="main-text">
                  <p v-for="j in item.multipleArr[tabIndex].light" :key="j">
                    {{ j }}
                  </p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/java/box4/03.png"
                    alt
                  />可掌握的能力
                </div>
                <div class="main-text">
                  <p v-for="k in item.multipleArr[tabIndex].ability" :key="k">
                    {{ k }}
                  </p>
                </div>
              </div>
            </template>
            <div v-else>
              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/01.png"
                  alt
                />主要内容
              </div>
              <div class="main-content">
                <div
                  :class="[
                    index == 4 ||
                    index == 6 ||
                    index == 7 ||
                    index == 8 ||
                    index == 9
                      ? 'main-text2'
                      : 'block',
                  ]"
                  v-for="i in item.content"
                  :key="i"
                >
                  {{ i }}
                </div>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/02.png"
                  alt
                />特色亮点
              </div>
              <div class="main-text">
                <p v-for="j in item.light" :key="j">{{ j }}</p>
              </div>

              <div class="title-icon">
                <img
                  src="../../../assets/coursePage/java/box4/03.png"
                  alt
                />可掌握的能力
              </div>
              <div class="main-text">
                <p v-for="k in item.ability" :key="k">{{ k }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      tabIndex: 0,
      subject: [
        {
          stage: "阶段一",
          title: "Java核心与AI开发基础",
          content: [
            "Java基础语法",
            "AI辅助工具",
            "程序流程控制",
            "数组",
            "面向对象",
            "常用API",
            "商品管理系统",
          ],
          light: [
            "1. 在本阶段的学习中，学生不仅能够掌握 Java 编程技术，更重要的是可以学会如何利用 AI 解决编程问题。比如，如何通过 AI 攻克个人难以解决的编程难题，如何借助 AI 实现自动化编程。这些能力的获得，将大幅提升开发效率与综合编程水平，进而增强同学们在职场上的竞争力。",
            "2. 本阶段知识均以解决需求为导向，讲解不墨迹，思路清晰，案例极其丰富。",
          ],
          ability: [
            "1. 掌握Java程序的开发步骤",
            "2. 掌握企业里的开发工具：IDEA的基本使用，以及AI工具的使用",
            "3. 掌握Java程序的基本组成单元，以及基本语法",
            "4. 能够阅读并修改AI自动产生的各种Java代码",
            "5. 能够结合AI并运用所学的Java基础技术独立完成Java基础阶段的综合小项目",
          ],
        },
        {
          stage: "阶段二",
          title: "Java核心与AI开发进阶",

          content: [
            "集合",
            "异常",
            "File类",
            "常用API",
            "IO流",
            "多线程",
            "网络编程",
            "Java高级技术",
          ],
          light: [
            "1. JavaSE进阶阶段的内容更加深入，案例更加丰富，会涉及到底层源码和设计模式的讲解。",
            "2. 本阶段课程为了保证学生的学习效果和解决实际需求的场景，均采用讲A练B的学习模式，比如课上通过讲解A项目讲解某些Java技术点，课下会提供B项目让学生练习。",
            "3. 学完本阶段，你将至少获得如下能力：",
            "<i>a. 熟练掌握Java语言的基础编程，深度理解Java语言的设计思想。</i>",
            "<i>b. 初步具备运用AI来解决Java编程需求的能力，并可以阅读、修改AI自动产生的各种Java程序。</i>",
          ],
          ability: [
            "1. 掌握Collection、Map集合的定义和常用API",
            "2. 掌握项目开发中异常的正确处理方式",
            "3. 掌握自定义异常的方式",
            "4. 掌握File类的使用方式",
            "5. 掌握企业项目开发的常用API和IO流",
            "6. 掌握多线程的创建和使用",
            "7. 掌握线程池的创建和使用",
            "8. 掌握反射的作用和使用方式",
            "9. 掌握自定义注解的原理和使用场景",
            "10. 理解动态代理的好处，能够编写动态代理程序",
            "11. 理解集合底层原理",
            "12. 理解网络编程思想，能够自己编写出简单的TCP通信程序",
          ],
        },
        {
          stage: "阶段三",
          title: "AI赋能Web开发",

          content: [
            "HTML",
            "CSS",
            "JS",
            "Ajax",
            "Axios",
            "Maven",
            "MySQL",
            "JDBC",
            "Mybatis",
            "SpringBoot",
            "Spring",
            "SpringMVC",
            "Vue3",
            "ElementPlus",
            "Linux",
            "Docker",
            "Tlias智能学习辅助系统",
          ],
          light: [
            "1. 企业级项目驱动教学：基于SpringBoot3最新技术栈，通过真实商业项目案例贯穿教学，每个知识点均匹配实际应用场景，确保学完即用、无缝对接企业开发需求。知识点讲解循序渐进，重视知识通用性讲解，能够举一反三，重视能力的培养。",
            "2. 全流程开发能力培养：系统化构建学员从需求拆解、编码实现、测试验证到服务器部署的完整Web开发认知体系，掌握软件生命周期核心方法论。",
            "3. AI全链路开发提效：将AI深度整合到需求分析、数据库设计、代码生成、接口联调等全开发环节，显著提升开发效率，培养智能编程时代的核心竞争力。",
            "4. 工业级开发规范内化：在项目实战中渗透代码规范、接口文档、测试用例等企业级工程标准，培养符合行业要求的职业化开发素养。",
          ],
          ability: [
            "1. 需求分析与AI辅助开发能力：能够精准拆解项目需求，转化为自然语言描述，并熟练运用AI工具完成需求分析、代码生成、Bug修复等全流程开发任务。",
            "2. 全栈开发与工程实践能力：熟练掌握基于SpringBoot3+Vue3的前后端分离架构，具备从系统设计、开发到容器化部署的前端架构实战能力。",
            "3. 典型业务场景解决方案能力：掌握用户认证、对象存储等Web项目高频业务场景的标准化实现方案。",
            "4. 云原生部署与运维能力：能够基于Linux+Docker完成前后端项目的环境配置、容器化部署。",
            "5. AI提效开发方法论：深入理解AI辅助开发模式，能通过智能工具显著提升设计、编码效率，以及故障排查速度。",
          ],
        },
        {
          stage: "阶段四",
          title: "企业级智能物联网项目（中州养老）",

          content: [
            "中州养老是一个智能化养老服务管理系统，主要面向养老服务机构，提供信息化管理方案，实时掌握老人健康和护理情况，提升服务质量和管理效率。项目还涉及表结构、接口和单体架构设计，以及接口性能、索引优化等高级内容。 ",
          ],
          light: [
            "1. 课程全程采用 AI 工具辅助开发。",
            "2. 课程讲解重点培养系统设计能力，包含了数据库设计、接口设计、技术方案设计等。",
            "3. 课程采用低代码平台若依框架，实现快速开发和部署。",
            "4. 课程中对接了百度千帆大模型，为解决实际业务挑战提供高效助力。",
            "5. 课程包含了前端 Vue3+Element plus 组件完成页面开发，助你向全栈工程师靠拢。",
            "6. 通过开发复杂业务，让你具备性能优化、接口优化、SQL 优化的能力，使系统更高效。",
            "7. 注重代码质量，选择合适的设计模式调整代码结构，让你的代码更简洁，易扩展。",
            "8. 采用了 RBAC 模型+Spring security 完成权限认证，让你掌握后台管理系统权限的通用解决方案。",
            "9. 采用华为云物联网 IOT 平台，让你掌握智能硬件数据监测全流程。",
            "10. 采用 MOTT 协议异步接收 IOT 平台的海量数据，让你掌握异步消息的处理。",
            "11. 项目开发与实际项目开发接轨，采用敏捷式开发模式，让你掌握项目实际的开发流程。",
            "12. 真实还原了项目上线之后的 bug 寻找定位，让你掌握更多线上 bug 调试方案。",
            "13. 全程采用了项目开发常见工具，如:禅道、Git、Axure 等，让你无缝对接项目开发。",
          ],
          ability: [
            "1. 系统设计能力，包含产品需求分析、数据库设计、接口设计、技术方案设计等方面。",
            "2. 前端Vue3开发能力，包含了与后端接口对接联调、组合式API使用等能力。",
            "3. 系统优化能力，包含了性能优化、接口优化、SQL优化等能力。",
            "4. 解决问题的能力，包含了bug调试能力、在线调试工具使用能力等。",
            "5. Git使用能力，包含了Git分支管理、团队协作开发等能力。",
            "6. 项目部署能力，包含了项目打包，多环境、CICD持续集成部署能力。",
          ],
        },
        {
          stage: "阶段五",
          title: "微服务SCA",

          content: [
            "SpringCloud Aliaba",
            "Nacos",
            "OpenFeign",
            "Spring Cloud Gateway",
            "Seata",
            "Sentinel",
            "ElasticSearch",
            "Redis高级",
            "微服务项目常见技术方案",
            "常见面试题",
          ],
          light: [
            "1. 结合电商项目讲解企业从单体到微服务的真实拆分演进过程。",
            "2. 分层次教学，重点讲解企业微服务开发中最实用、频率最高的知识和最佳实践方案，面试内容统一总结。",
            "3. 结合真实项目学习，不仅学会，更要把知识用起来。",
            "4. 使用AI辅助编程训练，学习效率大大提升。",
          ],
          ability: [
            "1. 掌握SpringCloud Alibaba微服务技术栈；",
            "2. 掌握高可靠性的消息队列方案；",
            "3. 掌握分布式搜索解决方案；",
            "4. 掌握Redis高级知识及底层原理；",
            "5. 掌握微服务热点难点面试题及底层原理；",
            "6. 掌握单体项目迁移至微服务项目常见技术方案。",
          ],
        },
        {
          stage: "阶段六",
          title: "互联网分布式项目（云岚到家）",

          content: [
            "云岚到家是一个家政服务O2O平台，通过移动互联网连接家政人员和用户，支持在线下单、接单、抢单和上门服务。",
            "平台包含用户端（小程序）、服务端（App）、机构端（PC）和运营管理端（PC），采用前后端分离开发模式。",
            "后端基于Spring Cloud Alibaba架构，涵盖订单管理、派单、抢单、客户管理、优惠券、运营基础、公共和支付服务等模块。",
          ],
          light: [
            "1. 学员实战时可采用AI助手辅助开发，包括AI辅助设计、AI编码、AI代码审查、AI单元测试、AI代码优化等，大幅度提升开发效率。",
            "2. 项目采用主流的SpringBoot、Spring Cloud Alibaba技术栈，适用于大多数企业对单体项目及微服务项目的技术选型，学完可快速应用到企业开发中。",
            "3. 课程内容全面，包括：需求分析、设计、开发、测试、系统优化、运维等，学完将掌握Java中高级程序员在整个项目生命周期中所具备的重要技能。",
            "4. 课程采用渐进式设计模式，保证零基础小白从入门到精通循序渐进掌握大型项目的实战能力。",
            "5. 课程采用多项目教学，课堂授课与项目实战共涉及五个项目十几个业务模块，注重业务领域的深度学习及业务领域的迁移训练；注意业务解决方案与技术解决方案融合，讲授二十余个技术方案且通用性强，适合进行技术方案迁移。",
          ],
          ability: [
            "1. 掌握系统需求分析的流程与方法",
            "2. 掌握根据产品原型进行系统设计的方法",
            "3. 掌握基于三层架构的开发方法",
            "4. 掌握使用AI工具进行项目设计、编码、优化的开发方法",
            "5. 掌握运营基础管理模块的设计与开发方法",
            "6. 掌握客户管理模块的设计与开发方法",
            "7. 掌握门户模块的设计与开发方法",
            "8. 掌握订单管理模块的设计与开发方法",
            "9. 掌握支付模块的设计与开发方法",
            "10. 掌握优惠券活动管理模块的设计与开发方法",
            "11. 掌握抢券模块的设计与开发方法",
            "12. 掌握抢单模块的设计与开发方法",
            "…… ",
          ],
        },
        {
          stage: "阶段七",
          title: "Java+AI智能体应用开发",
          multipleArr: [
            {
              tab: "SpringAI+DeepSeek大模型应用开发",

              content: [
                "本课程聚焦于 SpringAI 与 DeepSeek 大模型的深度融合，专为 Java 程序员设计。",
                "课程深度整合 Spring 生态，巧妙运用 SpringBoot 自动装配与 AOP 技术，极大简化大模型应用开发流程，助力开发者轻松上手。",
                "通过系统化讲解大模型应用开发的核心技术与实战技巧，旨在打造每个 Java 程序员的必修技能，全面提升开发效率与项目质量。",
              ],
              light: [
                "1. Ollama：高效模型部署与管理，轻松实现多模型集成。",
                "2. SpringAI：深度整合 Spring 生态，简化开发流程，提升开发效率。",
                "3. Prompt Engineering：精准提示工程技巧，优化模型输出质量。",
                "4. Tool Calling：无缝对接业务系统，实现智能化功能扩展。",
                "5. 向量模型与向量数据库：高效知识表示与检索，助力智能应用升级。",
                "6. RAG Embedding：结合语义嵌入的知识检索增强，提升问答相关性。",
                "7. 多模态：支持文本、图像等多种模态交互，拓展应用边界。",
              ],
              ability: [
                "1. 能够描述AI大模型的核心原理及训练机制",
                "2. 能够对接OpenAI、阿里云百炼等主流AI大模型接口",
                "3. 能够基于OpenAI-SDK实现大模型的对话与工具调用（Tool Calling）​",
                "4. 能够通过Prompt Engineering设计高效提示词以优化模型输出​​",
                "5. 能够基于Spring AI实现普通对话及流式对话功能",
                "6. 能够通过System角色设定优化AI响应行为​​",
                "7. 能够利用Advisors功能增强AI模型的自定义逻辑",
                "8. 整合基于 Tool Calling 将 AI 能力与业务系统（如课程查询）整合，实现智能化业务流程",
                "9. 能够实现RAG检索增强方案",
              ],
            },
            {
              tab: "AIGC应用与智能体开发",

              content: [
                "星图 AI 项目是一款创新型互联网 AI 平台，致力于为用户提供引擎提供高效、便捷的文本转图像及视频生成服务。",
                "平台融合了文本生成图像（文生图）、图像间转换（图生图）、基于姿势生成图像（姿势生图）、图像画质增强以及文本和视频的直接转换（文生视频、图生视频）等前沿技术，极大丰富了用户的创作体验与表达形式。",
                "通过本课程，学员将全面掌握星图 AI 平台的核心技术与开发要点，具备独立开发类似复杂 AI 应用的能力。",
              ],
              light: [
                "1. 服务后端的 Websocket 客户端实现方案",
                "2. 分布式任务锁和信号量的协同方案（Redission）",
                "3. 基于 Websocket 的点对点、广播推送方案",
                "4. 基于复杂业务的数据流分解法 ",
                "5. 复式记账法方案",
                "6. 私有化部署大模型的方案（Ollama）",
              ],
              ability: [
                "1. 掌握 Ollama、ChatBot、知识库等私有化部署技术，实现安全可控的本地化 AI 服务。",
                "2. 深入学习 Stable Diffusion、ComfyUI 等 AIGC 文生图技术，打造高质量图像生成应用。",
                "3. 实现基于 Websocket 双端消息通信，构建实时交互的 web 应用。",
                "4. 理解并掌握复式记账法的设计与实现方案，确保数据的准确性和完整性。",
                "5. 运用 Redission 实现分布式锁、信号量，解决高并发场景下的资源竞争问题。",
                "6. 学会使用数据流分析法简化复杂业务逻辑，提升系统设计的清晰度和可维护性。",
                "7. 掌握 Retrofit 声明式客户端的使用，提高开发效率和代码可读性。",
              ],
            },
          ],
        },
        {
          stage: "阶段八",
          title: "BAT⼤⼚360°⾯试突击",

          content: [
            "面试专题是课程主要是加强在面试过程中的一些常见问题的讲解，本阶段课程基本覆盖中高级程序员面试题80%以上。包含了各个模块的面试题讲解，如：数据结构、Java集合源码分析、多线程、JVM、MySQL、SSM、微服务、Redis、消息队列、设计模式、高并发场景、企业实际问题场景等等各个方面逐一讲解。",
          ],
          light: [
            "1. Java集合中常见的面试题及必要的数据结构和源码分析",
            "2. 线程基础、线程安全、线程池、线程使用场景等面试题",
            "3. JVM组成、类加载器、垃圾回收、JVM调优实践等面试题",
            "4. SQL基础、事务、索引、调优、分库分表、锁相关的面试题",
            "5. Spring框架常见的面试题",
            "6. SpringMVC框架常见的面试题",
            "7. MyBatis框架常见的面试题",
            "8. SpringBoot框架常见的面试题",
            "9. SpringCloud框架、微服务常见的面试题",
            "10. 分布式事务常见的面试题",
            "11. Redis的数据结构、持久化、集群、使用场景、分布式锁、Key过期策略等常见的面试题",
            "12. RabbitMQ常见的面试题",
            "……",
          ],
          ability: [
            "1. 掌握常见的数据结构（复杂度分析、数组、链表、二叉树、红黑树、散列表）",
            "2. 掌握Java集合高频的面试题（ArrarList、HashMap）",
            "3. 掌握多线程高频面试问题（线程基础、线程安全、线程池、使用场景）",
            "4. 掌握JVM高频面试题（JVM组成、类加载器、垃圾回收、JVM实践）",
            "5. 掌握MySQL高频面试题（SQL基础、事务、索引、SQL调优、分库分表、锁）",
            "6. 掌握SSM高频面试题（Spring、SpringMVC、MyBatis）",
            "7. 掌握微服务高频面试题（SpringBoot、SpringCloud、分布式事务）",
            "8. 掌握Redis高频面试题（数据类型、持久化、主从和集群、使用场景、分布式锁）",
            "……",
          ],
        },
      ],
      subject2: [
        {
          stage: "阶段一",
          title: "分布式项目集",
          multipleArr: [
            {
              tab: "天机学堂",

              content: [
                "天机学堂是一个生产级的在线教育项目，是一家专注于非学历职业技能培训的“网校”。项目基于SpringCloudAlibaba微服务技术栈，包含在线教育、社交、电商等热点难点问题的企业解决方案，让我们的学员真正做到举一反三。同时项目的完整度、真实度、复杂度都与真实项目非常接近，教学过程遵循企业开发流程，旨在让学生体会真实企业开发，掌握微服务开发的常用技能。",
              ],
              light: [
                "1. 营造企业微服务开发环境，模拟企业内多服务器、多团队开发、部署过程",
                "2. 从进入公司拉取、阅读企业级代码，到自己开发功能，手把手带你度过“危险期”",
                "3. 分析需求和原型图，设计数据库表及实体，带你熟悉企业真实开发流程",
                "4. 拒绝技术堆叠式课程，真正做到技术为业务服务，游刃有余的用技术解决真实问题",
                "5. 利用Redis解决各种各样的问题，绝不仅仅是缓存和key-value存储",
                "6. 掌握电商项目优惠券系统设计方案，解决拆单、退费等热点、难点问题",
                "7. 多种设计模式的熟练应用",
                "8. 企业真实业务场景下的多线程并发编程、安全问题处理",
                "9. 融合在线教育、社交、电商等多种热门项目亮点、难点问题解决方案",
              ],
              ability: [
                "1. 掌握企业开发的基本模式",
                "2. 了解企业开发环境、持续集成环境的工作模式",
                "3. 掌握跨微服务的业务开发方式",
                "4. 学会基于产品原型和需求做业务流程分析",
                "5. 学会基于产品原型和需求做数据结构设计",
                "6. 学会基于产品原型和需求做接口设计",
                "7. 掌握在线教育项目中的学习辅助系统设计方案",
                "8. 掌握积分、排行榜等系统设计方案",
                "9. 掌握优惠券系统设计方案",
                "10.掌握常用中间件在微服务开发中的各种使用方式",
              ],
            },
            {
              tab: "四方保险",

              content: [
                "四方保险是一个金融保险销售SaaS平台，通过移动互联网为保险销售公司和客户提供了线上保险销售、产品发布、推荐、保费计算、收益计算、核保、承保、理赔等全流程服务。平台包含用户端（小程序）和保险销售管理端（PC）。项目包含7大核心模块：保险发布、保费计算、收益试算、保司承保、合同订单、随心配服务、扣款计划，以及oauth2.0权限服务、统一支付平台、数据采集埋点、对象存储服务、规则引擎等微服务。",
              ],
              light: [
                "1. 让您进去金融项目圈，本项目是目前市场唯一金融保险全业务链的实战型项目。",
                "2. 提升复杂项目的设计能力，包括：业务需求提炼、数据库结构设计通用技巧，微服务功能抽取能力、功能接口设计技巧，让您拥有高级开发人员的开发能力。",
                "3. 项目提供多种通用组件的构建，包括：微服务的OAuth2.0权限设计、统一支付平台、数据采集方案、对象存储服务、规则引擎等，学习完成后可以轻松迁移到其他项目。",
                "4. 课程采用半实战的实施方式，课程重分析、设计、代码能力提升，采用分组实战贴合企业项目开发的学习模式，学习后可以轻松胜任企业工作。",
              ],
              ability: [
                "1. 掌握微服务项目业务需求分析能力",
                "2. 掌握微服务项目模块的拆分设计能力",
                "3. 掌握SpringCloud的企业级开发框架的应用能力",
                "4. 掌握SpringCache+Redis的优雅的缓存处理能力",
                "5. 掌握跨业务对象存储实现文件统一管理包括：安全、上传、分片、下载的开发能力",
                "6. 掌握基于Oauth2.0的统一微服权限管理的开发能力",
                "7. 掌握基于SpringCloud-Stream消息驱动使用RabbitMQ的开发能力",
                "8. 掌握基于多种支付三方构建统一支付平台的开发能力",
                "9. 掌握基于多种短信服务商构建统一短信服务平台的开发能力",
                "10. 掌握基于SpringCloud-Gateway+InfluxDB数据采集分析平台的开发能力",
                "11. 掌握使用规则引擎处理业务分析判断的开发能力",
                "12. 掌握Seata分布式事务控制开发能力",
                "……",
              ],
            },
            {
              tab: "帝可得",

              content: [
                "帝可得是⼀个智能售货机项⽬，基于SpringCloud+MybatisPlus框架开发，并应用传智研究院⾃研的解决方案框架集 Elegent 解决接口幂等性、数据⼀致性、分布式锁、分布式事务、微服务模块解耦与异步调用，⽀付、权限、Token续期等企业开发中的通用问题。项⽬采用⼯业级物联⽹消息中间件EMQx，解决海量物联⽹设备消息通讯的问题。",
              ],
              light: [
                "1. 微服务权限解决方案",
                "2. 令牌续期解决方案",
                "3. 接口幂等性解决方案",
                "4. 数据⼀致性解决方案",
                "5. ⽀付解决方案",
                "6. 并发处理解决方案",
                "7. 微服务异步调用解决方案",
                "8. 分布式事务解决方案",
                "9. 物联⽹消息传输解决方案",
                "10. 地理位置搜索解决方案",
                "11. 数据同步解决方案",
                "12. 搜索解决方案",
              ],
              ability: [
                "1. 了解需求评审会的场景与常见问题",
                "2. 根据产品原型分析和理解项⽬整体需求",
                "3. 基于库表设计方法论进⾏库表设计",
                "4. 根据产品原型进⾏接口设计",
                "5. 熟练编写跨服务调用代码",
                "6. 熟练编写微服务异步调用的代码，理解ElegentAC框架的设计原理",
                "7. 掌握分布式事务的实现，理解ElegentACTX框架的设计原理",
                "8. 熟练掌握分布式锁的实现，理解ElegentLock框架的设计原理",
                "9. 掌握开发物联⽹项⽬的开发思路，熟练开发物联⽹项⽬",
                "10. 掌握在项⽬中对接和使用⽀付，理解ElegentPay框架的设计原理",
                "11. 掌握如何实现接口幂等性，理解ElegentIU 框架的设计原理",
                "12. 在项⽬中对接ElegentAuth实现权限控制，并理解ElegentAuth框架的设计原理",
                "13. 在项⽬中对接ElegentToken实现令牌签发、验签与续期，并理解ElegentToken框架的设计原理",
              ],
            },
            {
              tab: "工作流组件",

              content: [
                "工作流组件项目即是课程也是一个开源项目，基于SpringBoot+Activiti7+MybatisPlus框架开发，结合工作流+Lowcode(低代码)的前沿开发思想，在项目中给出了工作流+低代码表单整合、权限控制的解决方案，同时项目还深入Activiti7的应用，提供了开发者流程设计器、业务人员流程设计器、流程状态图、前加签、并加签、驳回等诸多功能的实现方案。项目还提供了流程中心微服务、流程设计器等开源工具，供你高效开发流程项目。学完项目后，可以带着工作流+低代码解决方案和开源工具到企业中解决实际问题，提升就业竞争力。",
              ],
              light: [
                "1. 采用了工作流+低代码的双重前沿架构",
                "2. 全面深入的应用BPNM+Activiti，真实还原企业工作流开发",
                "3. 提供了业务流程设计器、流程中心微服务等开源套件，帮助学员快速开发工作流功能",
                "4. 提供了架构设计模式、Netty等彩蛋供学员们深造学习",
                "5. 分层式课程设计，更适应多层次的学员学有所获",
                "6. 贯彻讲A练B模式，配套课后练习，让学员能够活学活用，快速提升动手能力",
                "7. 企业级实战练习，更进一步让学员能够活学活用，熟悉在企业级项目中集成工作流技术的能力",
              ],
              ability: [
                "1. 熟悉BPMN 36种图例",
                "2. 熟悉BPMN 条件分⽀、⽹关分⽀、协同分⽀的控制",
                "3. 掌握BPMN图例绘制复杂流程图的能力",
                "4. 了解OA系统的特点和核⼼功能的开发过程",
                "5. 掌握Activiti7 加签、抄送、驳回等22个办理功能的开发能力",
                "6. 掌握Activiti7 流程状态图的开发能力",
                "7. 掌握Lowcode低代码表单开发能力",
                "8. 掌握Activiti7与Lowcode低代码表单的整合能力",
                "9. 掌握⼀定的BPMN xml文件解析的能力",
                "10. 掌握⼀定的Activiti7 底层命令修改的能力",
                "11. 掌握⼀定的参数化单元测试的开发能力",
                "12. 掌握⼀定的编程式事务、事务传播的开发能力",
              ],
            },
          ],
        },
        {
          stage: "阶段二",
          title: "AI大模型开发进阶",

          content: [
            "本课程内容为学员提供全面的大模型微调所需Python编程技能，并深入探讨大模型的应用开发。首 先介绍Python核心基础语法，包括变量、输入输出、条件判断、循环结构、字符串操作等基础知 识，接着深入讲解常用数据结构（列表、元组、字典、集合）、推导式和函数等高级概念。随后，课程转向文件操作、异常处理以及模块导入等实用技能。在掌握了必要的Python编程基础后，课程将深入探讨大模型应用开发，特别是LangChain框架的基本概念及其应用场景，并通过实战项 目展示如何利用LangChain与ChatGLM实现本地知识库问答。最后，课程涵盖了大模型的主要微调方法，如全量微调、Prompt-Tuning、PEFT等，并通过一系列实际项目帮助学员掌握这些技术 的实际应用。",
          ],
          light: [
            "1. 全流程能力培养：从 Python 编程基础到企业级大模型微调落地，覆盖全流程能力培养，确保学员具备完整的开发技能。",
            "2. 核心技术深度解析：深入讲解提示词微调（Prompt-Tuning）和参数高效微调（PEFT/LoRA）等核心技术，结合实际案例展示其在优化模型性能中的优势。",
            "3. 多领域实战案例：提供医疗、金融、教育等多个领域的实战案例，帮助学员深入理解不同业务场景下的模型应用策略。",
            "4. LangChain 框架实战：通过 LangChain 框架构建本地知识库问答系统、聊天机器人等复杂应用，提升开发效率，拓展项目实战经验。",
            "5. Zero-shot 与 Few-shot 学习：重点突出零样本与少样本学习方法，使学员能够利用模型的泛化能力解决数据稀缺问题，快速响应业务需求。",
            "6. 多任务学习实战：通过多任务项目实战，培养学员的系统思维和综合应用能力，提升模型在复杂业务场景下的适应性。",
            "7. 企业级项目经验：模拟企业真实开发环境，提供完整项目开发流程的训练，帮助学员积累企业级项目经验，提升就业竞争力。",
          ],
          ability: [
            "1. 掌握核心概念与技术：深入理解大模型微调的核心概念，包括提示词微调（Prompt-Tuning）和参数高效微调（PEFT/LoRA），并熟练掌握其应用场景和技术细节。",
            "2. 全流程开发能力：具备从 Python 编程基础到企业级大模型微调的全流程开发能力，能够独立完成项目的开发与部署。",
            "3. 模型选择与优化：能够根据不同业务需求选择合适的主流大模型（如 GPT 系列、LLaMA、ChatGLM 等），并运用微调技术优化模型性能。",
            "4. 实战项目经验：通过丰富的实战项目，积累在医疗、金融、教育等多个领域的项目经验，提升解决实际问题的能力。",
            "5. LangChain 框架应用：熟练掌握 LangChain 框架的核心组件和应用场景，能够构建复杂的 LLM 应用，如本地知识库问答系统、聊天机器人等。",
            "6. 零样本与少样本学习：掌握 Zero-shot 和 Few-shot 学习方法，能够利用模型的泛化能力解决数据稀缺问题，快速响应业务需求。",
            "7. 多任务学习能力：能够设计和实现多任务学习项目，通过混合数据集构建和模型训练，提升模型在复杂业务场景下的适应性。",
            "8. 模型部署与集成：掌握模型的部署方法和集成技巧，能够将微调后的模型封装为 API 接口，支持业务系统的集成和调用。",
          ],
        },
      ],
      cur: -1,
      cur2: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.clickZiXun()
      }
      this.mai("JavaEE-就业课", "查看详细大纲", 0, null);
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeTabCur(index) {
      this.tabIndex = index;
    },
    changeCur2(index) {
      this.tabIndex = 0;
      this.cur = -1;
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur2) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur2 = index;
      }
      // console.log(this.$refs.item[index]);
      // console.log(this.$refs.item[index].offsetTop, this.prevItemHeight);
      // this.goTop(index);
    },
    changeCur(index) {
      this.tabIndex = 0;
      this.cur2 = -1;
      this.$nextTick(()=>{
        const a = document.querySelector(".show-answer");
        if (a != null && index > this.cur) {
          this.prevItemHeight = a.offsetHeight;
        }
        if (!this.showAnswer || index <= this.cur) {
          this.prevItemHeight = 0;
        }
        if (index == this.cur) {
          this.showAnswer = !this.showAnswer;
        } else {
          this.showAnswer = true;
          this.cur = index;
        }
        this.goTop(index);
      })
      
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
  },
};
</script>

<style lang="less" scoped>
.box4 {
  width: 750px;
  background: #edf3ff;
  .box4block {
    height: 80px;
  }
  .box4-top {
    position: relative;
  }
  .box4-title {
    position: relative;
    height: 96px;
    background: linear-gradient(270deg, #72b7fd 0%, #017fff 100%);
    box-shadow: 0px 0px 18px 0px #e2e7f1;
    border-radius: 16px;
    margin: 40px 32px 0;
    display: flex;
    align-items: center;
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #ffffff;
      line-height: 96px;
      text-align: left;
      font-style: normal;
      padding-left: 40px;
      b {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #ffffff;
        line-height: 96px;
        text-align: left;
        display: line-block;
        font-style: normal;
      }
    }
    a {
      width: 180px;
      height: 52px;
      display: block;
      background: #ffffff;
      border-radius: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #017fff;
      line-height: 52px;
      text-align: center;
      font-style: normal;
      margin-left: 74px;
    }
    img {
      width: 138px;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  .leftbgc {
    width: 144px;
    height: 178px;
    background: rgba(237, 219, 166, 0.23);
    position: absolute;
    left: 0;
    top: 0;

    filter: blur(50px);
  }
  .rightbgc {
    width: 396px;
    height: 179px;
    background: rgba(166, 192, 237, 0.23);
    right: 0;
    top: 0;
    position: absolute;
    filter: blur(50px);
  }
  .topWrap {
    width: 686px;
    margin: 48px auto 0px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 240px;
      height: 164px;
      background-size: cover;
      margin-right: -18px;
      overflow: hidden;
      margin-bottom: 20px;
      .img {
        width: 48px;
        height: 52px;
        margin: 30px 0 12px 78px;
        background-size: cover;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 44px;
        margin-left: 78px;
      }
    }
  }
  .box4-btm-box {
    padding-bottom: 88px;
    width: 100%;
    padding-top: 48px;
    // background: linear-gradient(180deg, #ffffff 0%, #f2f6ff 5%, #f2f6ff 100%);
    .box4-btm {
    }
  }

  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 480px;
    height: 88px;
    background: linear-gradient(270deg, #ff7a87 0%, #ff4659 100%);
    border-radius: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 30px;
    color: #ffffff;
    line-height: 88px;
    text-align: center;
    font-style: normal;
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
  }
  .tab {
    display: flex;
    margin: 20px -12px 40px -12px;
    a {
      display: block;
      padding: 8px 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #4e5969;
      line-height: 36px;
      text-align: center;
      font-style: normal;
      margin-right: 12px;
      background: #e4f3ff;
      border-radius: 26px;
    }
    a:last-child {
      margin-right: 0;
    }
    .current {
      background: #0a5bff;
      box-shadow: 0px 8px 16px 0px #b3deff;
      color: #fff;
    }
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 22px 0px 22px 35px;
    padding-right: 22px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    justify-content: space-between;

    .title {
      margin-right: 20px;

      display: flex;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #020941;
      line-height: 40px;
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 40px;
        color: rgba(64, 128, 255, 1);
        margin-right: 16px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 24px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;
    padding: 0px 40px 0px;

    .line {
      margin-bottom: 28px;
      width: 622px;
      height: 1px;
      margin-left: -8px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 40px 0px;
    border-radius: 16px;
    // display: block;
    max-height: 3200px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;
    img {
      margin-right: 14px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 24px;
    display: flex;
    flex-wrap: wrap;
    // margin-left: 45px;
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 16px;
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }
  }

  .main-text {
    margin-bottom: 40px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    // margin-left: 45px;

    p {
      text-indent: -27px;
      padding-left: 31px;
      // /deep/ i{
      //   margin-left: 31px;
      //    text-indent: -31px;
      //   padding-left: 62px;
      // }
    }
    .three{margin-left: 31px;}
   
  }
   p:nth-child(10), p:nth-child(11), p:nth-child(12), p:nth-child(13), p:nth-child(14) {
      text-indent: -40px;
      padding-left: 40px;
    }
  p:nth-child(11) {
    // text-indent: -40px;
    // padding-left: 40px;
    // margin-left: -7px;
  }
  .main-text2 {
    margin-bottom: 16px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
  }
}
</style>
